import React from 'react';

export default () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_50066_16082)">
        <path
          d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99988C12.8334 3.77822 10.2217 1.16655 7.00008 1.16655C3.77842 1.16655 1.16675 3.77822 1.16675 6.99988C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z"
          stroke="var(--text-color-3)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.91675 11.0832L11.0834 2.91655"
          stroke="var(--text-color-3)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_50066_16082">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
